"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of {@link BaselineAggregation BaselineAggregation}.
 * @author OPt
 */


var BaselineAggregationConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(BaselineAggregationConverter, _DataObjectConverter_);

  function BaselineAggregationConverter() {
    _classCallCheck(this, BaselineAggregationConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(BaselineAggregationConverter).apply(this, arguments));
  }

  return BaselineAggregationConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.BaselineAggregationConverter = BaselineAggregationConverter;